import { Controller, Toolbar } from '@tencent/workbench';
import { DigitNumberFeature } from './digit-number-feature';
import { TOOLBAR_ITEMS, config } from './config';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class DigitNumberController {
    constructor(private readonly feature: DigitNumberFeature) {
    }

    @Toolbar(config.id, 'onClick')
    public onClick() {
        this.feature.onClick();
    }

    @Toolbar(config.id, 'onArrowClick')
    public onArrowClick() {
        // workbench写法
    }

    @Toolbar(config.id, 'shouldCheck')
    public isChecked() {
        const index = this.feature.getSelectedIndex();
        return index !== -1 && index !== 0;
    }

    @Toolbar(config.id, 'dropdownContent')
    public showContent() {
        return this.feature.showContent(true);
    }
}
